import React, { useEffect, useState, useMemo, useCallback } from 'react';
import styles from '../../styles/modules/components/slot-selection.module.scss';
import { connect, useDispatch } from 'react-redux';
import { removeItem, setinstaCount, setSlotApiCount, slotSelectionShown, slotSelectionValid, slotShow, toggleCartAlert, updateIsDisable, updateLoading, updateSlotData, fetchSlotData, updateSlotSelectionData } from '../../redux/actions/cartActions';
import { generateStaticDates } from '../../utils/selfserve/index'
import { HOMECARE_PLAN_LIST } from '../../constants'
import SlotPicker from './SlotPicker'
import { slotSelectionAllSlotsSelected, slotSelectionNoSlotsAvailable, slotSelectionViewed } from '../../tracking/segment/checkoutPage';


const SlotSelection = (props: any) => {
    const [selctionDisabled, setSelectionDisabled] = useState(false);
    const [instaItems, setInstaItems] = useState(0);
    const [groupedCategory, updatedGroupedCategory] = useState<any>([]);
    const dispatch:any = useDispatch()

    const isCart = useMemo(() => props.selectionType === "cart", []);

    const normalizeCartDate = useCallback((cartItem) => {
        const tempCategory = String(cartItem['category']).toLowerCase();
        return {
            category_type: cartItem['category_type'], //"Air Conditioner",
            category: cartItem['category'],           //"Split AC",
            display_title: cartItem['display_title'], //"Repair",
            product_title: cartItem['product_title'], //"AC Repair", 
            product_type: cartItem['product_type'],   //"Wet Preventive Maintenance"
            quantity: Number(cartItem['quantity']),   //2,
            brand: (tempCategory === 'ipad' || tempCategory === 'iphone' || tempCategory === 'apple laptop') ? 'Apple' : 'Non-Apple', //Apple, Non-Apple
            sku: cartItem['sku'],
        };
    }, []);

    const normalizeServiceRequestData = useCallback((serviceRequest) => {
        return {
            category: '',
            category_type: serviceRequest['device_detail']?.['category_type'] || 'home care sr',
            display_title: '',
            product_title: '',
            product_type: serviceRequest['selected_cover']?.['cover_details'][0]['cover_title'],
            quantity: 1,
        };
    }, []);

    const groupByCategory = useCallback(() => {
        if (isCart) {
            return Object.values(props.cart.items.reduce((groupedItems, item) => {
                if (item.group === "insta-repair") {
                    if (!groupedItems[item.category_type]) {
                        groupedItems[item.category_type] = [];
                    }
                    groupedItems[item.category_type].push(normalizeCartDate(item));
                }
                return groupedItems;
            }, {}))
        }
        if (props.selectionType === "selfServe") {
            if (HOMECARE_PLAN_LIST.includes(props.selfserveReducer?.planDetails?.category_type)) {
                dispatch({
                    type: 'ADD_SR_SLOT_SELECTION_DATA',
                    data: { slots: generateStaticDates(30), isDateAvailable: true, items: [{ category_type: props.selfserveReducer?.planDetails?.category_type }] },
                });
            }
            return Object.values(props.selfserveReducer.serviceRequests).map((srItem) => {
                return [normalizeServiceRequestData(srItem)]
            })
        }
    }, [isCart, props.cart.items, props.selfserveReducer.serviceRequests]);

    const removeItemCategory = (itemCategoryType: string) => {
        const itemData = props.cart.items.filter((cartItem) => cartItem['category_type'] === itemCategoryType);
        if (itemData) {
            if (itemData.length == props.cart.items.length) {
                props.toggleCartAlert({
                    toggle: true,
                    toggleType: "slotCartRemove",
                    data: {
                        data: itemData,
                    }
                })
            }
            else {
                setInstaItems(!groupedCategory ? 0 : groupedCategory.length - 1)
                itemData.map(item => {
                    props.removeItem({
                        application: 'website',
                        id: item.id, quantity: item.quantity,
                        token_id: props.cart.token_id,
                    }, item.quantity, true)
                    //props.updateSlotSelectionData([]);
                })
            }
        }
    }

    const handleSrSlotSelection = useCallback((selectedSlot: { category: { services: [], date: string, time: string } }) => {
        let slotData = Object.values(selectedSlot)[0];
        props.handleSlotDate(slotData['preferred_date_1']);
        props.handleTimeSlotChange(slotData['preferred_time_slot_1']);
    }, []);

    const getSlots = (items) => {
        if (items.length === 0) return;
        const payloadVariables = items.reduce((details, item) => {
            if (!details.cover_dict[item.product_type]) {
                details.cover_dict[item.product_type] = 0;
            }
            details.cover_dict[item.product_type] += item['quantity'];
            if (!details.brandList.includes(item['brand'])) {
                details.brandList.push(item['brand']);
            }
            return details;
        }, { cover_dict: {}, brandList: [] });
        let payLoad = {
            'category': JSON.stringify(items[0]['category_type']),
            'brand_list': JSON.stringify(payloadVariables.brandList),
            'pincode': JSON.stringify(props.cart.updatedPincode),
            'cover_names': JSON.stringify(payloadVariables.cover_dict),
            'application': 'website',
            'sub_application': props.selectionType,
            'sku':JSON.stringify(items[0]['sku']),
        };
        props.fetchSlotData({ 'payLoad': payLoad, 'items': items });
    }

    const syncSlotData = useCallback((groupedItems, tempSlotData) => {
        return groupedItems.reduce((updatedSlotData, items) => {
            if (tempSlotData[items[0]['category_type']]) {
                updatedSlotData[items[0]['category_type']] = tempSlotData[items[0]['category_type']];
            }
            return updatedSlotData;
        }, {});
    }, []);

    const validateSlot = useCallback((slotData) => !Object.values(slotData).some((data: any) => data.preferred_date_1 === '' || data.preferred_time_slot_1 === ''), []);

    useEffect(() => {
        const itemsStringified = groupByCategory();
        if (JSON.stringify(groupedCategory) !== JSON.stringify(itemsStringified)) {
            updatedGroupedCategory(groupByCategory());
        }
    }, [props.cart.items]);

    useEffect(() => {
        if (validateSlot(syncSlotData(groupedCategory, props.cart.slotData)) || (props.isAgent && !selctionDisabled && !props.cart.nonServiceablePincode)) {
            props.slotSelectionValid(true);
        } else {
            props.slotSelectionValid(false);
        }
    }, [props.cart.slotData, groupedCategory]);

    useEffect(() => {        
        if (isCart && props.cart.updatedPincode != '' && groupedCategory?.length !== 0) {
            props.updateSlotData(syncSlotData(groupedCategory, props.cart.slotData));
            dispatch({ type: "UPDATE_SLOT_SELECTION_DATA", data: [] });
            const tempInstaPlans = groupedCategory?.length || 0;
            props.setSlotApiCount(tempInstaPlans);
            props.setinstaCount(tempInstaPlans);
            props.updateLoading(false);
            if (tempInstaPlans) {
                props.slotShow(true);
                props.slotSelectionShown(true);
            } else {
                props.slotSelectionShown(false);
                props.slotSelectionValid(true);
            }
            if (instaItems === 0 || instaItems === groupedCategory?.length) {
                setInstaItems(0)
                groupedCategory?.map((items) => {
                    getSlots(items);
                })
            }
        } else if (groupedCategory.length === 0) {
            props.slotSelectionShown(false);
        }
    }, [groupedCategory, props.cart.edit_id, props.cart.updatedPincode]);

    useEffect(() => {
        const tempInstaPlans = groupedCategory?.length || 0;
        props.setinstaCount(tempInstaPlans);
        props.updateLoading(false);
        if (tempInstaPlans) {
            props.slotShow(true);
            props.slotSelectionShown(true);
        } else {
            props.updateLoading(false);
        }
    }, [props.cart.isPersonalDetailsValid]);

    const slotSelectionDate = useMemo(() => {
        if (isCart) {
            setSelectionDisabled(props.cart?.slotSelectionData?.some(slot => !slot['isDateAvailable']));
            return props.cart.slotSelectionData
        }
        return props.selfserveReducer.slotSelectionData
    }, [props.cart.slotSelectionData, props.selfserveReducer.slotSelectionData]);

    React.useEffect(()=>{
        if(props.cart.isPersonalDetailsValid && props.cart.isSlotSelectionShown){
            slotSelectionViewed({'source':'cart page'})             
        }
    },[props.cart.isSlotSelectionShown])

    React.useEffect(()=>{
        if(props.cart.isPersonalDetailsValid && props.cart.isSlotSelectionShown && selctionDisabled){
            slotSelectionNoSlotsAvailable({'pincode':props.cart.updatedPincode,'source':'cart page'})
        }
    },[props.cart.isSlotSelectionShown,selctionDisabled])

    React.useEffect(()=>{
        if(props.cart.isSlotSelectionShown && props.cart.isSlotSelectionValid && validateSlot(props.cart.slotData)){
            slotSelectionAllSlotsSelected({'pincode':props.cart.updatedPincode, 'source':'cart page'})
        }
    },[props.cart.isSlotSelectionValid])

    return (
        <div className={`${styles.slot_picker_container} ${isCart ? styles.cart_slot_selection : styles.sr_slot_selection}`}  id="slotpicker">
            {
                slotSelectionDate.map((items) => <SlotPicker {...items}
                    isnonServiceablePincode={props.cart.nonServiceablePincode}
                    removeCateory={removeItemCategory}
                    slotData={isCart ? props.cart.slotData : {}}
                    updateSlotData={isCart ? props.updateSlotData : handleSrSlotSelection}
                    isCart={isCart}
                    isDisabled={selctionDisabled}
                    isAgent={props.isAgent}
                    pinCode={isCart ? props.cart.updatedPincode : props.selfserveReducer.customerDetails.address.pincode} />)
            }
        </div>
    );
}

const mapStateToProps = (state: any) => {
    return {
        cart: state.cart,
        selfserveReducer: state.selfserveReducer,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        removeItem: (item: any, quantity: number, force: boolean) => dispatch(removeItem(item, quantity, force)),
        slotSelectionValid: (data: boolean) => dispatch(slotSelectionValid(data)),
        slotSelectionShown: (data: boolean) => dispatch(slotSelectionShown(data)),
        updateIsDisable: (data: any) => dispatch(updateIsDisable(data)),
        updateSlotData: (data: any) => dispatch(updateSlotData(data)),
        updateLoading: (data: boolean) => dispatch(updateLoading(data)),
        slotShow: (data: boolean) => dispatch(slotShow(data)),
        setSlotApiCount: (data: number) => dispatch(setSlotApiCount(data)),
        setinstaCount: (data: number) => dispatch(setinstaCount(data)),
        toggleCartAlert: (data: any) => dispatch(toggleCartAlert(data)),
        fetchSlotData: (data: any) => dispatch(fetchSlotData(data)),
        updateSlotSelectionData: (data: any) => dispatch(updateSlotSelectionData(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SlotSelection);